export const useResultLimit = ({
  page,
  size,
  resultLimitSize = 10000,
  resultLimitMessage = "You have reach the maximum amount of pages, use the filters to find the provider that's best for you",
}) => {
  const resultLimitAchieved = page * size > resultLimitSize;
  return { resultLimitAchieved: resultLimitAchieved, resultLimitMessage: resultLimitAchieved ? resultLimitMessage : null };
};
